import * as pathToRegexp from 'path-to-regexp'

export enum ShoppingService {
  MY = 'MY',
  REVIEW = 'REVIEW',
  TAGPICK_BRIDGE = 'TAGPICK_BRIDGE',
  TAGPICK_MY = 'TAGPICK_MY',
  GIFT = 'GIFT',
}

type ShoppingServiceType = { [key in ShoppingService]: ShoppingServiceConfig }

export const shoppingServiceConfig: ShoppingServiceType = {
  MY: {
    service: ShoppingService.MY,
    name: '마이',
    path: '/my',
    pathname: 'my',
  },
  REVIEW: {
    service: ShoppingService.REVIEW,
    name: '리뷰',
    path: '/reviews',
    pathname: 'reviews',
  },
  TAGPICK_BRIDGE: {
    service: ShoppingService.TAGPICK_BRIDGE,
    name: '태그Pick 브릿지',
    path: '/tagpick/tags',
    pathname: 'tagpick/tags',
  },
  TAGPICK_MY: {
    service: ShoppingService.TAGPICK_MY,
    name: '태그Pick 설정',
    path: '/tagpick/my',
    pathname: 'tagpick/my',
  },
  GIFT: {
    service: ShoppingService.GIFT,
    name: '선물',
    path: '/gift',
    pathname: 'gift',
  },
}

export interface ShoppingServiceConfig {
  service: ShoppingService
  name: string
  path: string
  pathname: string
}

const SERVICE_INDEX = 1
const REDUCED_PATHS = Object.values(shoppingServiceConfig).reduce((result, currConfig) => {
  if (!result) {
    return currConfig.pathname
  }
  return `${result}|${currConfig.pathname}`
}, '')
const PATH_PATTERN = `/(${REDUCED_PATHS})/(.*)*`
const re = pathToRegexp(PATH_PATTERN)

export const getServiceByPath = (pathname: string): ShoppingService => {
  const pathParams = re.exec(pathname)
  if (!pathParams || pathParams.length < SERVICE_INDEX) return
  return getService(pathParams[SERVICE_INDEX])
}

export const getService = (pathname: string): ShoppingService => {
  const service = Object.keys(shoppingServiceConfig).find(
    service => shoppingServiceConfig[service].pathname === pathname,
  )
  return ShoppingService[service]
}
